import React, { useMemo, useRef, useEffect } from "react";
import { Node, Transforms } from "slate";
import { ErrorBoundary } from "react-error-boundary";
import styled from "styled-components";
import { useSlate, ReactEditor } from "slate-react";
import EditorElement from "./newEditorElement";
import { useState } from "react";
import { insertVariable } from "./VariableElement/transforms/insert-variable";
import CancelButton from "../../..//NewEditor/cancelButton.js";
import EditButton from "../../..//NewEditor/EditButton.js";
import HandleVariableClic from "../../..//NewEditor/HandleVariableClic.js";

function ErrorFallback({ error }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}

const BaseElement = React.forwardRef(
  (
    {
      className,
      element,
      type,
      children,
      contentStyle,
      showPlaceholder,
      BaseElementComponent = "div",
      textAlign,
      ...attributes
    },
    ref
  ) => {
    const [content, hasVariable, hasImage] = useMemo(() => {
      const children = Array.from(Node.elements(element));

      const hasVariable = children.some(([c]) => c.type === "variable");
      const hasImage = children.some(([c]) => c.type === "image");

      return [Node.string(element), hasVariable, hasImage];
    }, [element]);

    const isEmpty = useMemo(
      () => showPlaceholder && !hasVariable && !hasImage && !content.length,
      [showPlaceholder, content]
    );

    // const { setCurrentElement } = useEditorActions();

    const [currentEditableItem, setCurrentEditableItem] = React.useState(false);
    const [editMode, setEditMode] = useState(false);
    const [isEditorOff, setIsEditorOff] = React.useState(true);
    // const editMode = () => {
    //   setTimeout(() => {
    //     setCurrentEditableItem(!currentEditableItem);
    //   });
    // };
    const cancelEdit = () => {
      setCurrentEditableItem(false);
    };
    const setElement = () => {
      setCurrentEditableItem({});
    };
    const isElement = useRef();
    const [prevElement, setPrevElement] = useState();
    // useEffect(() => {
    //   console.log(element);
    // }, [element]);
    function getprevElement(element) {
      setPrevElement(element);
    }
    const editor = useSlate();
    const handleEditar = () => {
      setEditMode(true);
      setCurrentEditableItem(true);
      setIsEditorOff(false);
    };
    const [editorLocation, setEditorLocation] = useState(null);

    const handleAddVariable = (parsedData) => {
      Transforms.select(editor, editorLocation);

      insertVariable(editor, parsedData);
      Transforms.move(editor, { distance: 1, unit: "offset" });
      // console.log(editorLocation);
      // console.log(prevLocation);
    };

    useEffect(() => {
      if (editor.selection !== null) {
        setEditorLocation(editor.selection);
        // console.log(editorLocation);
        // console.log(prevLocation);
      }
      // console.log(editor);
    }, [editor.selection]);

    const prevLocation = useRef(editorLocation);
    useEffect(() => {
      const point = {
        anchor: { path: [0, 0], offset: 0 },
        focus: { path: [0, 0], offset: 0 },
      };
      if (editMode === true) {
        ReactEditor.focus(editor);
        Transforms.move(editor, { distance: 1, unit: "offset" });
      }
    }, [editMode]);
    useEffect(() => {
      if (editorLocation !== null) {
        prevLocation.current = editorLocation;
      }
      console.log(editor.selection);
    }, [editorLocation]);

    useEffect(() => {
      if (currentEditableItem === true && editMode === true) {
        var parentDiv = document.getElementById("insertEditorHere");
        // console.log(typeof parentDiv);
        var childEditor = document.getElementById("editor--to--insert");
        if (typeof parentDiv === "object" && typeof childEditor === "object") {
          parentDiv.appendChild(childEditor);
        }
      }
    }, [editMode]);
    const removeChild = () => {
      var parentDiv = document.getElementById("originalEditoContainer");
      var childEditor = document.getElementById("editor--to--insert");
      if (typeof parentDiv === "object" && typeof childEditor === "object") {
        parentDiv.appendChild(childEditor);
      }
      setCurrentEditableItem(false);
      setEditMode(false);
    };

    const path = window.location.pathname.split("/").pop();
    // console.log(path);
    // useEffect(() => {
    //   console.log(currentEditableItem);
    // }, [currentEditableItem]);
    const [variableToDrag, setVariableToDrag] = useState("");
    const dropVariable = () => {
      Transforms.select(editor, editorLocation);
      insertVariable(editor, variableToDrag);
    };

    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {prevLocation.current !== editorLocation && path === "edit" && (
          <HandleVariableClic
            onAddVariable={handleAddVariable}
            prevState={editorLocation}
          />
        )}
        {editMode && (
          <div
            className="EditorParentDiv"
            contentEditable={false}
            style={{ userSelect: "none" }}
          >
            <div
              id="insertEditorHere"
              contentEditable={false}
              style={{ userSelect: "none" }}
            ></div>
            <CancelButton
              removeChild={removeChild}
              currentElement={element._id}
            />
          </div>
        )}
        <div
          {...attributes}
          ref={ref}
          style={
            currentEditableItem ? { display: "none", userSelect: "none" } : {}
          }
          className={className}
          data-element-id={element._id}
          data-element-type={type}

          //  Capture={(e) => {
          //   console.log(editor.selection);
          // }}
          // onDragOverCapture={() => {
          //   console.log(editor.selection);
          // }}
        >
          {path === "edit" && (
            <EditButton
              handleEditar={handleEditar}
              currentElement={element._id}
              closeEditField={removeChild}
              action={"clic"}
            />
          )}
          <BaseElementComponent
            element={element}
            type={type}
            content={content}
            hasVariable={hasVariable}
            hasImage={hasImage}
            isEmpty={isEmpty}
          >
            {path === "edit" && (
              <EditButton
                handleEditar={handleEditar}
                currentElement={element._id}
                closeEditField={removeChild}
                action={"doubleClic"}
              />
            )}
            <div
              className="item-wrapper position-relative"
              style={{
                ...contentStyle,
                textAlign: textAlign || element.textAlign,
              }}
              type={type}
            >
              {children({ isEmpty })}
            </div>
          </BaseElementComponent>
        </div>
      </ErrorBoundary>
    );
  }
);

export default BaseElement;
export function GetEditor() {
  const editor = useSlate();
  return editor;
}
function BaseElementNoEditableField({ className, children, style }) {
  return (
    <span
      className={className}
      contentEditable={false}
      style={{ ...style, userSelect: "none" }}
      suppressContentEditableWarning
    >
      {" "}
      {/*style={{ userSelect: "none" }}*/}
      {children}
    </span>
  );
}

const StyledBaseElementNoEditableField = styled(BaseElementNoEditableField)`
  font-weight: ${(props) => props.fontWeight || "normal"};
  font-size: ${(props) => props.fontSize || "16px"};
`;

function BaseElementPlaceholder({ text, style }) {
  return (
    <span
      className="text-muted"
      contentEditable="false"
      suppressContentEditableWarning
      style={{
        pointerEvents: "none",
        display: "inline-block",
        width: "0",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        opacity: 0.333,
        position: "absolute",
        height: 0,
        ...style,
      }}
    >
      {text}
    </span>
  );
}

BaseElement.NoEditableField = StyledBaseElementNoEditableField;
BaseElement.Placeholder = BaseElementPlaceholder;

// export const withBaseElement = () => (editor) => {
//     const { normalizeNode } = editor;

//     editor.normalizeNode = ([currentNode, currentPath]) => {

//         if (currentNode.type === 'table-wrap') {
//             console.log({currentNode, currentPath})
//             Transforms.setNodes(editor, {
//                 children: [{
//                     type: 'base_element',
//                     children: currentNode.children,
//                 }]
//             }, {
//                 at: currentPath
//             })
//         }

//       return normalizeNode([currentNode, currentPath]);
//     };

//     return editor;
//   };

// export function renderBaseElement(params) {
//     return (props) => {
//       if (props.element.type === 'base_element') {
//         return (
//             <BaseElement {...props} {...params} />
//         );
//       }

//       return undefined;
//     }
//   }

//   export const BaseElementPlugin = ({ setCurrentElement = noop } = {}) => ({
//     renderElement: renderBaseElement({ setCurrentElement }),
//   });
